const publicDocument = {
  'pages.material.public.Document.relevance.device': '关联器件',
  'pages.material.public.Document.basic': '基本信息',
  'pages.material.public.Document.field.unit': '单位',
  'pages.material.public.Document.delete.document': '删除文档',
  'pages.material.public.Document.delete.hint':
    '是否确认删除 {documentName} 文档 删除后无法恢复，是否确认？',
}
export default publicDocument
